import React from 'react';
import './numberbtn.css'

const Numberbtn = (props) => {
    return (
        <>
            <div className={props.stylebox}>
                <div className="text">
                    <h1 className={props.textstyle} >{props.number}</h1>
                    <p className={props.textstylep}>{props.text}</p> 
                </div>
                    <img className={props.imgclass} src={props.imgsrc} alt="/" />

            </div>
        
        </>
      );
}
 
export default Numberbtn;